import { t } from 'services/i18n.service';
import { PropsWithChildren } from 'react';
import GoogleAuth from './third-party/GoogleAuth';
import AppleAuth from './third-party/AppleAuth';
import AuthActionHeader from './AuthActionHeader';
import { isDesktopLoginRequest } from 'services/auth.service';

interface Props extends PropsWithChildren {
  isSelected: boolean;
  title: string;
  subTitle?: string;
  showWelcomeUI?: boolean;
}

const SignInUpWrapper = ({
  children,
  isSelected,
  title,
  subTitle,
  showWelcomeUI = true
}: Props) => {
  return (
    <div
      className={`w-full h-fit flex-col items-center justify-center ~gap-5/10 animate-fadeIn ${isSelected ? 'inline-flex' : 'hidden'} overflow-x-auto scrollbar-thin dark:scrollbar-thumb-secondary-dark-500 dark:scrollbar-track-secondary-dark-200`}>
      <AuthActionHeader title={title} subTitle={subTitle} />
      {children}
      <div
        className={`${showWelcomeUI ? 'flex' : 'hidden'} flex-col ~gap-6/8 ~my-2/0 w-full`}>
        <div className='w-full border border-gray-300 dark:border-secondary-dark-500 relative'>
          <p className='w-fit uppercase absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 ~px-3/6 bg-secondary-50 dark:bg-secondary-dark-300 text-gray-600 dark:text-secondary-dark-900 ~text-xs/sm'>
            {t('auth_page.or')}
          </p>
        </div>
        <div className='flex flex-col ~gap-5/8 ~py-2/4'>
          <GoogleAuth />
          <AppleAuth />
        </div>
      </div>
      {isDesktopLoginRequest && (
        <p className='~mt-2/4 text-center text-primary-900 dark:text-primary-dark-500 ~text-xs/sm animate-pulse'>
          {t('auth_page.signing_in_and_redirecting_to_desktop_app')}
        </p>
      )}
    </div>
  );
};

export default SignInUpWrapper;
